import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { SuggestedPrompt } from '../../services/suggestedPromptsService';

interface SuggestedPromptsProps {
  prompts: SuggestedPrompt[];
  onPromptClick: (promptText: string) => void;
  isEdvisor?: boolean;
}

const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({ 
  prompts, 
  onPromptClick, 
  isEdvisor = true 
}) => {
  const theme = useTheme();

  if (!prompts || prompts.length === 0) {
    return null;
  }

  return (
    <Box 
      sx={{ 
        mt: 2, 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: 1,
        justifyContent: 'flex-start'
      }}
    >
      {prompts.map((prompt) => (
        <Button
          key={prompt.id}
          variant="outlined"
          size="small"
          onClick={() => onPromptClick(prompt.text)}
          data-button-label={prompt.text}
          data-prompt-id={prompt.id}
          data-prompt-category={prompt.category}
          className="message-button suggested-prompt-button"
          sx={{
            borderColor: isEdvisor ? theme.palette.primary.main : theme.palette.grey[400],
            color: isEdvisor ? theme.palette.primary.main : theme.palette.text.primary,
            '&:hover': {
              borderColor: isEdvisor ? theme.palette.primary.dark : theme.palette.grey[600],
              backgroundColor: isEdvisor ? theme.palette.primary.light : theme.palette.grey[100],
              color: isEdvisor ? '#ffffff' : theme.palette.text.primary,
            },
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            maxWidth: '300px',
            whiteSpace: 'normal',
            textAlign: 'left',
            height: 'auto',
            minHeight: '36px',
            padding: '6px 12px',
            fontSize: '0.875rem',
            textTransform: 'none',
            borderRadius: 2,
          }}
        >
          {prompt.text}
        </Button>
      ))}
    </Box>
  );
};

export default SuggestedPrompts;
